<template>
  <v-card>
    <v-card-title>Projects</v-card-title>

    <ListCard :items='projects' />
  </v-card>
</template>

<script>
import { mdiGooglePlay, mdiWeb, mdiApple } from '@mdi/js'
import ListCard from '../ListCard'

export default {
  name: 'Projects',
  components: {
    ListCard,
  },
  data(){
    return {
      projects: [
        {
          src: '/img/projects/karakoygourmet.png',
          alt: 'KarakoyGourmet App',
          name: 'KarakoyGourmet App',
          summary: 'KarakoyGourmet is an e-commerce grocery in Dubai. Karakoygourmet App is a mobile application developed with Flutter for KarakoyGourmet.',
          dialog: false,
          details: false,
          links: [
            {
              icon: mdiWeb,
              href: 'https://karakoygourmet.com/',
              color: 'black'
            },
            {
              icon: mdiGooglePlay,
              href: 'https://play.google.com/store/apps/details?id=com.app1001.karakoy',
              color: '#3bccff'
            },
            {
              icon: mdiApple,
              href: 'https://apps.apple.com/us/app/karakoy/id1362559889',
              color: '#A2AAAD'
            }
          ]
        },
        {
          src: '/img/projects/narlink.png',
          alt: 'Narlink',
          name: 'Narlink',
          summary: 'Narlink is a bio in the link web application and online bookmarks for teams.',
          dialog: false,
          details: false,
          links: [
            {
              icon: mdiWeb,
              href: 'https://narlink.xyz',
              color: 'black'
            },
          ]
        }
      ],
    }
  }
}
</script>

<style>

</style>